import {IConfigFilesVersionsModel} from "./IConfigFilesVersionsModel";
import {getLogger} from "@goodgamestudios/logger";
import Event = createjs.Event;
import {URLRequest, URLLoaderService} from "@goodgamestudios/createjs-utilities";

const logger = getLogger("ConfigFilesVersionsModel");

export class ConfigFilesVersionsModel implements IConfigFilesVersionsModel {
    private static _instance: ConfigFilesVersionsModel;
    private _versionData: any;

    public static get instance(): IConfigFilesVersionsModel {
        if (ConfigFilesVersionsModel._instance == null) {
            ConfigFilesVersionsModel._instance = new ConfigFilesVersionsModel();
        }
        return ConfigFilesVersionsModel._instance;
    }

    public loadVersionJson(url: string): Promise<void> {

        return new Promise<void>((resolve, reject) => {
            if (!this._versionData) {
                let loader = new URLLoaderService(new URLRequest(url));
                loader.load().then(response => {
                    logger.debug("versions loaded successfully");
                    this._versionData = JSON.parse(response);
                    loader.dispose();
                    resolve();
                }).catch(error => {
                        logger.warn("Error while loading/parsing version json");
                        loader.dispose();
                        reject(error);
                    }
                )
            }
            // Don't load it twice
            // apparently old implementation does not allow to delete current data nor load a different json.
            else {
                logger.debug(`ConfigFilesVersionsModel already contains data, loading of ${url} will be skipped.`);
                resolve();
            }
        });
    }

    public languageVersion(languageKey: string): number {
        return this._versionData.languages[languageKey];
    }

    public networkVersion(networkKey: number): number {
        return this._versionData.networks[networkKey];
    }

    public get countryVersion(): number {
        return this._versionData.country;
    }

    public dispose() {
        this._versionData = null;
        ConfigFilesVersionsModel._instance = null;
    }
}

